import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Label from 'core/components/label/label';
import useStyles from './aor-run-detail.styles';

/** One offer row of an apply report: the P6 branch's `details` (#33092). */
const OfferResultRow = ({ details, error, showError }) => {
  const classes = useStyles();
  const offerId = details.offerId ?? '—';

  return (
    <TableRow>
      <TableCell>
        <Link to={`/offer/${offerId}`} target="_blank" rel="noopener noreferrer">
          <Label type="action" className={classes.tableLink}>
            {offerId}
          </Label>
        </Link>
      </TableCell>
      <TableCell>{details.offerDate || '—'}</TableCell>
      <TableCell>{details.oldAffinity || '—'}</TableCell>
      <TableCell>{details.newAffinity || '—'}</TableCell>
      <TableCell>{details.affinityOutcome ?? '—'}</TableCell>
      {showError && <TableCell className={classes.errorCell}>{error ?? '—'}</TableCell>}
    </TableRow>
  );
};

OfferResultRow.propTypes = {
  details: PropTypes.object.isRequired,
  error: PropTypes.string,
  showError: PropTypes.bool
};

OfferResultRow.defaultProps = {
  error: null,
  showError: false
};

export const offerResultVariant = {
  key: 'offers',
  label: 'offers',
  columns: ['Offer', 'Quoted', 'From', 'To', 'Affinity'],
  rowKey: (details) => details.offerId,
  // Key presence, not truthiness: a worker that failed before it could read the record still emits
  // `offerId: ''`, and that row must reach the offers table rather than the fallback.
  matches: (details) => 'offerId' in details,
  Row: OfferResultRow
};

export default OfferResultRow;
